import React from "react";
import type { BaseProvinceIconProps } from "./BaseProvinceIcon";

export const OntarioIcon = (props: BaseProvinceIconProps) => {
  return (
    <path
      id="ON"
      {...props}
      d="M179.2,204.6c0.3,0,0.7,0.1,1.1,0.4c5.7,3.8,12.2,4.5,18.8,4.8c3,0.1,10.3,0.9,13.3,1.3
        c0.7,0.1,1.6,0.9,2,1.6c3.6,5.7,16.6,37.2,19.8,45.8c0.4,1.1,1.4,2,2.6,2.1c8.9,1.4,17.8,2.8,26.7,4.2c2.2,0.4,3.5,2,5,3.5
        c0.6,0.6,0.5,1.6-0.2,2.1c-3.2,2.4-6.1,4.7-9.3,6.5c-2.9,1.7-4,4.1-4,7.1c-0.1,2.1-1,3.3-2.8,4.3c-5,2.8-14.8,8.3-17.9,9.9
        c-0.6,0.1-0.9-0.2-0.9-0.6c0.3-3.2,1.3-12.6,1.5-15.2c0-0.4,0.3-0.7,0.7-0.8c1.6-0.3,5.5-1.1,7-1.4c-0.3-2.2-1.7-3.5-3.6-3.5
        c-0.1,0-0.3,0-0.4,0c-5.2,0.4-10.4,0.9-15.7,1.2c-0.7,0-1.5-0.5-1.9-1c-1.6-2.5-3-5.1-4.6-7.6c-0.9-1.4-2.1-2.6-3.4-3.5
        c-2.6-1.9-5.5-3.5-8.1-5.4c-0.5-0.3-0.9-0.5-1.3-0.5s-0.8,0.2-1.3,0.4c-3.6,2.1-7.3,4.2-10.9,6.1c-0.7,0.4-1.6,0.6-2.4,0.6
        c-5-0.4-19.8-2.4-22-2.5c-1.1,0-1.6-0.5-1.7-1.5c-0.9-7.8-1.9-15.5-2.8-23.3c-0.3-2.5-0.8-5.1-0.9-7.6c-0.1-1.1,0.1-2.4,0.7-3.2
        c5.1-7.9,10.4-15.7,15.5-23.5C178.2,205.1,178.6,204.6,179.2,204.6L179.2,204.6z"
    />
  );
};
